<template>
  <div>
    <HeaderNavbar
      :title="$t('settings.all_settings')"
      :breadcrumbs="[{ label: $t('nav.settings'), path: { name: 'settings' } }]" />
    <div class="container-lead">
      <div class="mt-3">
        <div class="responsive-padding row gy-3">
          <RouterLink v-for="card in settingsCards" :key="card.title" :to="card.to" v-slot="{ navigate }" custom>
            <div class="col-12 col-md-6 col-xl-3">
              <div class="card m-0 nav-card selectable-card" @click="navigate">
                <div class="card-body">
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <component :is="card.icon" class="nav-icon"></component>
                    <h3 class="pt-3 text-nowrap fw-bold">{{ card.title }}</h3>
                    <p class="text-muted m-0">{{ card.subtitle }}</p>
                  </div>
                </div>
              </div>
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import HeaderNavbar from '@/components/header/HeaderNavbar.vue';
import { IconUsers, IconBuilding, IconShare, IconWallet, IconLayoutKanban, IconListDetails } from '@tabler/icons-vue';
import translator from '@/locale/translator';
import { useUserStore } from '@/stores/user';
import { useCustomerFeaturesStore } from '@/stores/customerFeatures';

/* --------------------------------- STATE -------------------------------- */
const userStore = useUserStore();
const featureStore = useCustomerFeaturesStore();

// the swimlane admin page is only relevant to admins of customers with the ec_data_vault feature
const showSwimlanes = computed(() => Boolean(userStore.currentUser?.is_admin && featureStore.featureEcDataVault));

const settingsCards = computed(() => {
  const cards = [
    {
      title: translator.get('settings.accounts.title'),
      subtitle: translator.get('settings.accounts.description'),
      icon: IconUsers,
      to: { name: 'settings.accounts' },
    },
    {
      title: translator.get('settings.companies.title'),
      subtitle: translator.get('settings.companies.description'),
      icon: IconBuilding,
      to: { name: 'settings.companies' },
    },
    {
      title: translator.get('settings.linked_networks.title'),
      subtitle: translator.get('settings.linked_networks.description'),
      icon: IconShare,
      to: { name: 'settings.networks' },
    },
    {
      title: translator.get('settings.sub_budgets.title'),
      subtitle: translator.get('settings.sub_budgets.description'),
      icon: IconWallet,
      to: { name: 'billing.vbudgets' },
    },
  ];

  if (showSwimlanes.value) {
    cards.push({
      title: translator.get('settings.swimlanes.title'),
      subtitle: translator.get('settings.swimlanes.subtitle'),
      icon: IconLayoutKanban,
      to: { name: 'settings.swimlanes' },
    });
    cards.push({
      title: translator.get('settings.candidate_fields.title'),
      subtitle: translator.get('settings.candidate_fields.subtitle'),
      icon: IconListDetails,
      to: { name: 'settings.candidate_fields' },
    });
  }

  return cards;
});
</script>

<style lang="scss" scoped>
.nav-card {
  text-align: center;
  padding: 2rem 0;
  height: 100%;

  .nav-icon {
    width: 80px;
    height: 80px;
    stroke-width: 1;
    // color: var(--tblr-blue);
    color: #333;
  }
}
</style>
